import '@shui/core/sh-checkbox';

import { booleanAttribute, Component, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-checkbox',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.accessible-label]': 'accessibleLabel() ?? null',
        '[attr.active]': 'active() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.error]': 'error() ? "" : null',
        '[attr.error-message]': 'errorMessage() ?? null',
        '[attr.indeterminate]': 'indeterminate() ? "" : null',
        '[attr.label]': 'label() ?? null',
        '[attr.neutral]': 'neutral() ? "" : null',
        '[attr.readonly]': 'readonly() ? "" : null',
        '(checked)': 'checkedChange.emit($event)'
    }
})
export class ShCheckboxComponent {
    /**
     * Allows overriding the default aria-label for localization or context-specific information.
     */
    public readonly accessibleLabel = input<string | number | undefined>(undefined);

    /** Defines if a Toggle is selected or not. Changes when clicked. */
    public readonly active = input(false, { transform: booleanAttribute });

    /** If set, disabled styles will be applied */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /** If true, visually indicates an error state. */
    public readonly error = input(false, { transform: booleanAttribute });

    /** Optional error message shown below the label. */
    public readonly errorMessage = input<string | number | undefined>(undefined);

    /**
     * Defines if a checkbox is indeterminate. If true, it will show a 'minus' icon in the checkbox
     * when checked instead of the tick icon.
     */
    public readonly indeterminate = input(false, { transform: booleanAttribute });

    /** Defines the label of the checkbox. */
    public readonly label = input<string | number | undefined>(undefined);

    /** If true, the active state will be gray instead of orange. */
    public readonly neutral = input(false, { transform: booleanAttribute });

    /**
     * If true, the checkbox is non-interactive, but the label keeps its appearance and remains
     * fully readable.
     */
    public readonly readonly = input(false, { transform: booleanAttribute });

    public readonly checkedChange = output<Event>();
}
